import { useState } from 'react';
import { createContext, useContext } from 'react';

export const SharedStateContext = createContext();

export const SharedStateProvider = ({ children }) => {
    const [sharedState, setSharedState] = useState({
        profile : {},
        logs : [],
        admin : {},
    });

    return (
        <SharedStateContext.Provider value={{ sharedState, setSharedState }}>
            {children}
        </SharedStateContext.Provider>
    );
} 

export const useSharedState = () => {
    return useContext(SharedStateContext);
}   